export default __webpack_public_path__ + "static/PlusSaleIcon-e5c9356fa0237488e276df8a6ce361ab.svg";